import { TimeElement, TimeText } from './ScheduleTime.styled';

import React from 'react';
import dayjs from 'dayjs';

interface ScheduleTimeProps {
  selectedTime: string;
  setTime: (time: string) => void;
  startTime: string;
  endTime: string;
}
export const ScheduleTime = ({ selectedTime, setTime, startTime, endTime }: ScheduleTimeProps) => {
  const handleSetTime = () => {
    setTime(startTime);
  };

  if (!startTime || !endTime) return null;

  return (
    <TimeElement isSelected={selectedTime === startTime} onClick={handleSetTime}>
      <TimeText isSelected={selectedTime === startTime}>
        {dayjs(new Date(startTime)).format('hh:mm a')} - {dayjs(new Date(endTime)).format('hh:mm a')}
      </TimeText>
    </TimeElement>
  );
};
